module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAKCAYAAACXDi8zAAAAbklEQVQYV33POw5BYRAG0DMNUdiG3qWzA2uwWaJw16BAqIVEPzLyF7fAtOebV2TmBi/sIuKuVWTmGjMcsY+IZ1nBFB3mOGEbEY8ozcwJFi1wweEDDUdYYoXbEMatq+A6HFXp2nNG/3v5v3O/PvgGXcs23o8m+7YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/admin/downBefore.png
// module id = zk04
// module chunks = 2